export default "__VITE_ASSET__DgQZw0GX__"